// extracted by mini-css-extract-plugin
var _1 = "FileImagePreviewError-moduleinfo__g9aeG FilePreview-modulefileInfo__MgWZk";
var _2 = "FileImagePreviewError-modulesize__GC07R FilePreview-modulesize__qUfth";
var _3 = "FileImagePreviewError-moduletext__ZQxWD FilePreview-moduletext__DF9j8";
export { _1 as "info", _2 as "size", _3 as "text" }
